import styled from "styled-components";

const Logo = styled.img.attrs({ src: "/favicon.svg" })`
  display: block;
`;

export default Logo;
